import ComboToppings from "./ComboToppings";
export default class CustomizedMenuRightModal extends React.Component {
    constructor(props) {
        super(props);
        this.submenus = [];
        this.renderSubmenus = [];
        this.state = {
            selectedItemForSubs: this.props.currentSelectedItems || [],
            updateIds: 0,
            isMenuState: true,
            modalVistedBefore: false,
            allCheckedSubs: [],
            isMultipleBatch: false,
            subModalCheckedState: [],
            subMenus: null,
            fetchChildren: []
        };

        this.falsyValues = [];
        this.submenusComponent = [];
        this.submenuHeader = "";
        this.submenuParentTitle = "";
        this.ComboToppingsParentName = "";
        this.fetchChildren = [];
        this.updatedToppingName = "";
        this.pancakeSelection = "";
        this.childDataReturn = [];
        this.updatedPrice = 0;
        this.multipleTitles = [];
        this.modalNameSelector = this.props.tiTle;
        this.allcheckedSubceckedBoxes = [];
        this.appendedId = "";
        this.appendedIdForSubs = "";
        this.getUpdatedheaderTitleForSeleactedHeadingAndPrice = null;

        this.bindMethods();
    }

    bindMethods() {
        this.returnComboExtraToppingsComponent = this.returnComboExtraToppingsComponent.bind(this);
        this.saveAndCloseModal = this.saveAndCloseModal.bind(this);
        this.getDataForToppingsSubmenus = this.getDataForToppingsSubmenus.bind(this);
        this.passDataForCommaJoining = this.passDataForCommaJoining.bind(this);
        this.closeButtonHandler = this.closeButtonHandler.bind(this);
        this.getDataForCommaJoiningForSubs = this.getDataForCommaJoiningForSubs.bind(this);
        this.getUpdatedToppingsHeaderTitleAndPrice = this.getUpdatedToppingsHeaderTitleAndPrice.bind(this);
        this.checkIfCardIsSelected = this.checkIfCardIsSelected.bind(this);
        this.getRequiredText = this.getRequiredText.bind(this);
        this.updateRequiredStatusOnCardSelection = this.updateRequiredStatusOnCardSelection.bind(this);
        this.getIsMenuState = this.getIsMenuState.bind(this);
        this.passUpdatedEditMode = this.passUpdatedEditMode.bind(this);
        this.getAppendedData = this.getAppendedData.bind(this);
        this.getCheckedState = this.getCheckedState.bind(this);
        this.passUpdatedPrice = this.passUpdatedPrice.bind(this);
        this.passApendedId = this.passApendedId.bind(this);
        this.passApendedIdForSubs = this.passApendedIdForSubs.bind(this);
        this.getIsMultipleBatch = this.getIsMultipleBatch.bind(this);
    }

    checkIfCardIsSelected(cardId) {
        if (!this.state.selectedItemForSubs) return false;
        const cardIdInt = parseInt(cardId, 10);
        return this.state.selectedItemForSubs.some(item => {
            const subtitleIds = Array.isArray(item.subtitleId) ? item.subtitleId : [item.subtitleId];
            return subtitleIds.some(subId => parseInt(subId, 10) === cardIdInt);
        });
    }

    passUpdatedEditMode(EditModeStatus) {
        this.props.sendUpdatedEditMode(EditModeStatus);
    }

    getRequiredText(selectedCard, i) {
        if (selectedCard.IsRequired) {
            return this.updateRequiredStatusOnCardSelection(selectedCard, i);
        } else {
            return null;
        }
    }

    updateRequiredStatusOnCardSelection(selectedCard, i) {
        const { maxselects, IsRequired, id } = selectedCard;
      //  console.log("updateRequiredStatusOnCardSelection called with selectedCard:", selectedCard, "maxselects:", maxselects, "IsRequired:", IsRequired, "i:", i);
        const itemCount = $(`#batch${i} #comboRadioBtn > input[type=checkbox]:checked`).length || 0;
        const moreOptionCount = $(`#batch${i} #moreOptions > i[data-selected="selected"]`).length || 0;
        const totalCount = itemCount + moreOptionCount;
       //console.log("updateRequiredStatusOnCardSelection called with selectedCard:", selectedCard, "itemCount:", itemCount, "moreOptionCount:", moreOptionCount, "totalCount:", totalCount);
        if (IsRequired) {
            const selectCount = maxselects || 1;
            if (totalCount >= selectCount) {
                return (
                    <span className="default-required" data-category-id={id} data-isCompleted="true">
                        - <i className="combo-completed-text">Completed</i>
                    </span>
                );
            } else {
                return (
                    <span className="default-required" data-category-id={id} data-isCompleted="false">
                        - <i className="combo-required-text">{this.props.requiredText}</i>
                    </span>
                );
            }
        } else {
            return null;
        }        
    }

   

    componentDidMount() {
        const reactRefThis = this;
        $('#comboSaveButton').click(() => {
            reactRefThis.saveAndCloseModal();
        });

        $('#comboModalCloseBtn').click(() => {
            if ($("#subMenusContainer").css("display") === "none") {
                $("#comboModalCloseBtn").attr("data-dismiss", "modal");
            }

            if ($("#modalContent").css("display") === "none") {
                $("#comboModalCloseBtn").attr("data-dismiss", "noModal");
                $("#subMenusContainer").hide();
                $("#modalContent").show();
                $(".modal-body").scrollTop(0);
                $('#comboSaveButton').attr("data-modifierlevel", "first");
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
         //  console.log("CustomizedMenuRightModal componentDidUpdate called with prevProps:", prevProps, "prevState:", prevState, "current state:", this.state);    
           if (prevProps.mainId !== this.props.mainId) {
               this.setState({ updateIds: 0 });
           }
            if (prevProps.updateView !== this.props.updateView) {
               this.setState({ updateIds: 10 });
           }

           if (prevState.selectedItemForSubs !== this.state.selectedItemForSubs) {
           }
       }

    getCheckedState(checkedState) {
        if (typeof checkedState === 'string' && checkedState.includes("batch")) {
            this.allcheckedSubceckedBoxes = this.allcheckedSubceckedBoxes.filter(subToBeRemoved => checkedState !== subToBeRemoved.batchNo);
        } else if (this.allcheckedSubceckedBoxes.length > 0) {
            this.allcheckedSubceckedBoxes.map(subToBeReplaced => {
                if (checkedState.modalNmame === subToBeReplaced.modalNmame &&
                    checkedState.parentName === subToBeReplaced.parentName &&
                    checkedState.batchNo === subToBeReplaced.batchNo) {
                    subToBeReplaced.label = checkedState.label;
                    subToBeReplaced.componentId = checkedState.componentId;
                } else {
                    this.allcheckedSubceckedBoxes.push(checkedState);
                }
            });
        } else {
            this.allcheckedSubceckedBoxes.push(checkedState);
        }

        this.setState(prevState => ({ updateIds: prevState.updateIds + 1 }));
    }

    returnComboExtraToppingsComponent(toppingdData, parentName) {
        const toppingsCompSet = [];
        let thereIsMore = false;

        toppingdData[0].Modifiers.map((topping, i) => {
            if (topping.optionGroups.length > 0) {
                thereIsMore = true;
                this.submenuHeader = topping.optionGroups[0].Name;
                this.submenuParentTitle = topping.MenuItemDetail.Name;

                const childIds = topping.optionGroups[0].Modifiers[0].ImageAltWithFallback;
                this.submenus.push({
                    parentID: topping.MenuItemDetail.Name,
                    parentTrueId: topping.MenuItemDetail.Id,
                    childId: childIds,
                    Component: this.returnComboExtraToppingsComponent(topping.optionGroups, topping.MenuItemDetail.Name)
                });
            } else {
                thereIsMore = false;
            }

            if (topping.MenuItemDetail.Name) {
                toppingsCompSet.push(
                    <ComboToppings
                        toppingsNames={topping.MenuItemDetail.Name}
                        toppingCalories={topping.MenuItemDetail.BaseCalories}
                        toppingId={topping.MenuItemDetail.Id}
                        selectedItemForSubs={this.state.selectedItemForSubs}
                        updateSelectedItemsForSubs={updatedSelectedItems => this.setState({ selectedItemForSubs: updatedSelectedItems })}
                        key={topping.MenuItemDetail.Id}
                        sendDataForToppingsSubmenus={this.getDataForToppingsSubmenus}
                        thereIsMore={thereIsMore}
                        maxselects={toppingdData[0].maxselects}
                        minselects={toppingdData[0].minselects}
                        sendDataForCommaJoining={this.passDataForCommaJoining}
                        image={topping.MenuItemDetail.ImagePath}
                        modifierSlugName={topping.MenuItemDetail.ModifierSlugName}
                        isDefaultItem={topping.MenuItemDetail.IsDefault}
                        price={topping.MenuItemDetail.CalcPrice}
                        parentHeaderTitle={this.props.tiTle}
                        parentHeaderId={this.props.mainId}
                        checkBoxInfoForReset={this.props.getCheckBoxInfoForReset}
                        currentSelectedItems={this.props.currentSelectedItems}
                        submenusParentTitle={this.submenuParentTitle}
                        sendUpdatedToppingsHeaderTitleAndPrice={this.getUpdatedToppingsHeaderTitleAndPrice}
                        sendDataForCommaJoiningForSubs={this.getDataForCommaJoiningForSubs}
                        sendIsSubmenuState={this.getIsMenuState}
                        isMultipleBatch={this.getIsMultipleBatch}
                        sendAppendedData={this.getAppendedData}
                        sendCheckedState={this.getCheckedState}
                        subMenusState={this.state.subModalCheckedState}
                        submenuObj={this.submenus}
                        sendUpdatedPrice={this.passUpdatedPrice}
                        childDataForSubmodalId={this.state.fetchChildren}
                        sendAppendedId={this.passApendedId}
                        sendAppendedIdForSubs={this.passApendedIdForSubs}
                        noOfBatches={this.props.toppingsInfo}
                        isRequired={this.props.isRequired}
                        parentComponentName={parentName}
                        multipleCheckedSubs={this.allcheckedSubceckedBoxes}
                        caloriesText={this.props.caloriesText}
                        calorieAbbr={this.props.calorieAbbr}
                        calorieAdds={this.props.calorieAdds}
                        calorieSubtracts={this.props.calorieSubtracts}
                        isEditMode={this.props.isEditMode}
                        sendUpdatedEditMode={this.passUpdatedEditMode}
                    />
                );
            }
        });

        return toppingsCompSet;
    }

    passApendedId(appendedId) {
        this.appendedId = appendedId;
    }

    passApendedIdForSubs(appendedIdForSubs) {
        this.appendedIdForSubs = appendedIdForSubs;
    }

    passUpdatedPrice(updatedPrice) {
        this.updatedPrice = updatedPrice;
    }

    passDataForCommaJoining(commaSeparatedData) {
        this.updatedToppingName = commaSeparatedData;
        this.props.commaSeparatedDataToParent(commaSeparatedData);
    }

    getAppendedData(appendedData) {
        this.props.sendppendedData(appendedData);
    }

    getDataForToppingsSubmenus(ParentToppingName) {
        this.pancakeSelection = ParentToppingName;
        this.renderSubmenus = this.submenus.filter(submenu => submenu.parentID === ParentToppingName);

        this.setState({
            subMenus: this.renderSubmenus[0].Component
        });

        $('#comboSaveButton').attr("data-modifierlevel", "second");

        const truthyDefaultItem = this.renderSubmenus[0].Component.filter(aSub => aSub.props.isDefaultItem === true);

        if (truthyDefaultItem.length > 0) {
            if (!this.props.isEditMode) {
                if (this.props.shouldSelectedItemsBeRemoved) {
                    $('#information_modal').modal('hide');
                    const selectedToppingId = $("#moreOptions i[data-selected='selected']").attr('data-toppingid');
                    const toppingParentID = selectedToppingId;
                    const SelectedItemsKey = `default-mod-${toppingParentID}`;

                    sessionStorage.setItem([SelectedItemsKey], JSON.stringify({
                        selectedItem: truthyDefaultItem[0].props.toppingsNames,
                        selectedItemId: truthyDefaultItem[0].props.toppingId
                    }));

                    const allCheckedSubs = {
                        isChecked: true,
                        label: truthyDefaultItem[0].props.toppingsNames,
                        parentName: ParentToppingName,
                        subPrice: truthyDefaultItem[0].props.price,
                        modalNmame: truthyDefaultItem[0].props.parentHeaderTitle,
                        batchNo: "batch0",
                        componentId: truthyDefaultItem[0].props.toppingId
                    };

                    this.allcheckedSubceckedBoxes.push(allCheckedSubs);
                }

                const preselecetdSub = [];
                const preselecetdSubId = [];

                preselecetdSub.push(`${ParentToppingName}, ${truthyDefaultItem[0].props.toppingsNames}`);
                preselecetdSubId.push(`${this.renderSubmenus[0].parentTrueId}, ${truthyDefaultItem[0].props.toppingId}`);

                this.props.sendPreselectedForSubs({
                    parentTitle: truthyDefaultItem[0].props.parentHeaderTitle,
                    newValue: preselecetdSub.join(", ").toString(),
                    listOfIds: preselecetdSubId.join(", ").toString(),
                    totalPrice: parseFloat(truthyDefaultItem[0].props.price)
                });
                this.props.sendChoiceId();
            }
        }
    }

    getUpdatedToppingsHeaderTitleAndPrice(updatedTitleObj) {
        this.getUpdatedheaderTitleForSeleactedHeadingAndPrice = updatedTitleObj;
    }

    getDataForCommaJoiningForSubs(commaJoiningData) {
        this.props.sendCommaJoiningDataFormenuSub(commaJoiningData);
    }

    getIsMenuState(isMenuState) {
        this.setState({ isMenuState });
    }

    getIsMultipleBatch(mulipleState) {
        this.setState({ isMultipleBatch: mulipleState });
    }

    saveAndCloseModal() {
        const reactRefThis = this;

        let requiredStatus = 0;

        if ($("#modalContent").css("display") !== "none") {
            requiredStatus = $('#modalContent .combo-required-text').length
            if (requiredStatus > 0) {
                $('#modalContent .combo-required-text')[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                return false;
            }
        }
        if ($("#subMenusContainer").css("display") !== "none") {
            requiredStatus = $('#subMenusContainer .combo-required-text').length
            if (requiredStatus > 0) {
                $('#subMenusContainer .combo-required-text')[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                return false;
            }
        }

       

        if ($("#subMenusContainer").css("display") === "none") {
            const nameList = [];
            const listOfIds = [];
            let totalPriceOfaSelectionSet = 0;

            const allSelectedCheckBoxedToppings = $("#mainMenuContainer input[name='food']:checked");
            const allSelectedNonCheckedToppings = $("i[data-selected='selected']");

           Object.keys(sessionStorage).forEach(key => {
                if (key.startsWith("default-mod")) {
                    sessionStorage.removeItem(key);
                }
            });

            allSelectedCheckBoxedToppings.each(function () {
                const toppingId = this.dataset.toppingid;
                const toppingPrice = parseFloat(this.dataset.toppingprice);

                sessionStorage.setItem(`default-mod-${toppingId}`, JSON.stringify({
                    selectedItem: this.defaultValue,
                    selectedItemId: toppingId
                }));

                nameList.push(this.defaultValue);
                listOfIds.push(toppingId);
                totalPriceOfaSelectionSet += toppingPrice;
            });

            allSelectedNonCheckedToppings.each(function () {
                const toppingName = this.dataset.name;
                const toppingId = this.dataset.toppingid;
                const toppingPrice = parseFloat(this.dataset.toppingprice);

                const found = reactRefThis.allcheckedSubceckedBoxes.find(dropdownChildren => dropdownChildren.parentName === toppingName);

                if (found) {
                    sessionStorage.setItem(`default-mod-${toppingId}`, JSON.stringify({
                        selectedItem: found.label,
                        selectedItemId: found.componentId
                    }));

                    nameList.push(`${toppingName}, ${found.label}`);
                    listOfIds.push(`${toppingId}, ${found.componentId}`);
                    totalPriceOfaSelectionSet += toppingPrice + parseFloat(found.subPrice);
                } else {
                    nameList.push(toppingName);
                    listOfIds.push(toppingId);
                    totalPriceOfaSelectionSet += toppingPrice;
                }

                sessionStorage.setItem('selected-submenuid', toppingId);
            });

            if (this.props.cardOnlyPrice === 0) {
                setTimeout(() => {
                    const cardData = $(`div[data-modalid="${this.props.id}"]`);
                    const cardName = cardData[0].dataset.name;

                    this.props.cardOnlyPrice = sessionStorage.getItem(cardName) || 0;
                }, 700);
            }

            setTimeout(() => {
                reactRefThis.props.sendNameListForModalMultiples({
                    parentTitle: reactRefThis.props.tiTle,
                    newValue: nameList.join(", "),
                    listOfIds: listOfIds.join(", "),
                    totalPrice: totalPriceOfaSelectionSet + parseFloat(this.props.cardOnlyPrice)
                });

                reactRefThis.props.sendChoiceId();
                $("#noModal").attr("id", "information_modal");
                $('#information_modal').modal('hide');
            }, 1000);
        } else {
            reactRefThis.closeButton.click();
        }
    }

    closeButtonHandler(e) {
        if (this.closeButton.dataset.dismiss === "modal") {
            this.props.sendModalTriggerInfo(this.props.shouldSelectedItemsBeRemoved);
            this.props.IsCustomizedItem(false);
        } else {
            this.props.sendModalTriggerInfo(false);
        }
    }

    render() {
        if (this.props.triggerModalInputControlReset) {
            $('input[data-modalname="' + this.props.cardNameForModalReset + '"]').prop('checked', false);
            $('input[data-modalname="' + this.props.cardNameForModalReset + '"]').closest(".cart-items").removeClass("selected");

            $('i[data-modalname="' + this.props.cardNameForModalReset + '"]').prop('data-selected', "notSelected");

            this.allcheckedSubceckedBoxes = [];
            this.props.revertModalResetSatus(false);
        }

        const allToppings = this.props.toppingsInfo;
        const toppingStack = [];
        const allStack = [];
        const modalHeader = [];

        allToppings.map((allTopping, i) => {
            toppingStack.pop();
            toppingStack.push(allTopping);
            modalHeader.push(allTopping);

            allStack.push(this.returnComboExtraToppingsComponent(toppingStack, null));
        });

        return (
            <div>
                <div data-name={this.props.tiTle} data-modalid={this.props.id} className="modal modal_outer docked-right-modal fade rightModal2" id="information_modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel2" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="position-relative close-btn clearfix">
                                    <button onClick={this.closeButtonHandler} id="comboModalCloseBtn" tabIndex="0" ref={input => { this.closeButton = input; }} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <img src="/images/2/icons/ihop-modal-close.png" className="img-fluid" alt="Close Image" />
                                    </button>
                                </div>

                                <div id="modalContent" className="menu-category">
                                    <div className="category-body position-relative">
                                        <div className="add-toppings">
                                            <div id="mainMenuContainer" className="category-body position-relative mainMenuContainer2">
                                                {allStack.map((allTopping, i) => (
                                                    <div id={`batch${i}`}
                                                        data-minselects={modalHeader[i].minselects ?? "null"}
                                                        data-maxselects={modalHeader[i].maxselects ?? "null"}
                                                        data-isrequired={modalHeader[i].IsRequired}>
                                                        <div className="category-header">
                                                            <h2 className="h1 category-title" tabIndex="0" data-idCount={this.state.updateIds}>
                                                                {modalHeader[i].Name}
                                                                {this.getRequiredText(modalHeader[i], i)}
                                                            </h2>
                                                        </div>
                                                        {allTopping}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="subMenusContainer">
                                    <div className="menu-category mg-70">
                                        <div className="category-header">
                                            <h2 className="h1 category-title">{this.submenuHeader}</h2>
                                        </div>
                                    </div>
                                    {this.state.subMenus}
                                </div>

                                <div className="modal-footer floating-button">
                                    <button disabled={this.props.isRequired} id="comboSaveButton" type="button" tabIndex="0" className="btn btn-danger btn-lg btn-block">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
